export const BOOT_SPLASH_ELEMENT_ID = 'av-splash';

export const BOOT_SPLASH_DISMISSED_CLASS = 'av-splash--dismissed';

export const BOOT_SPLASH_CROSSFADE_MS = 160;
